
import { Options, Vue } from 'vue-class-component'
import Bestyrelsen from '@/components/Frontend/Bestyrelsen/index.vue'

@Options({
  components: {
    Bestyrelsen
  }
})
export default class BestyrelsenView extends Vue {}
